import qs from 'qs';
import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';

import { ROUTES } from 'src/constants';
import toast from 'src/components/Toast';

import CandidateOverview from './Candidate';
import EmployerOverview from '../NewLanding/Employer';
import EmployerFeaturesPage from '../NewLanding/Employer/Features';
import EmployerPricingPage from '../NewLanding/Employer/Pricing';
import EmployerArticlesPage from '../NewLanding/Employer/Articles';
import EmployerJobsPage from '../NewLanding/Employer/Jobs';
import EmployerJobApplicationPage from '../NewLanding/Employer/JobApplication';
import EmployerMagazinesPage from '../NewLanding/Employer/Magazines';
import EmployerResourcesPage from '../NewLanding/Employer/Resources';

const LandingPages = () => {
  const location = useLocation();
  const history = useHistory();
  React.useEffect(() => {
    const { notice } = qs.parse(location.search, {
      ignoreQueryPrefix: true
    });
    if (notice === 'signup') {
      toast.info(`
        In order to proceed please confirm your email.
        You can do this by following the link in the confirmation email we sent to you.
      `);

      history.push('/');
    }
  }, [history, location.search]);

  return (
    <Switch>
      <Route path={ROUTES.home} exact component={EmployerOverview} />
      <Route path={ROUTES.features} exact component={EmployerFeaturesPage} />
      <Route path={ROUTES.candidates} exact component={CandidateOverview} />
      <Route path={ROUTES.landingEmployerPricing} exact component={EmployerPricingPage} />
      <Route path={ROUTES.landingEmployerArticles + '/:id?'} component={EmployerArticlesPage} />
      <Route path={ROUTES.jobs.applications.new} exact component={EmployerJobApplicationPage} />
      <Route path={ROUTES.jobs.applications.application} exact component={EmployerJobApplicationPage} />
      <Route path={ROUTES.landingEmployerJobs + '/:id?'} component={EmployerJobsPage} />
      <Route path={ROUTES.landingEmployerMagazines + '/:id?'} component={EmployerMagazinesPage} />
      <Route path={ROUTES.landingEmployerResources + '/:id?'} component={EmployerResourcesPage} />
    </Switch>
  );
};

export default LandingPages;